import React, {useEffect} from 'react';
import {BrowserRouter, HashRouter, Route, Switch} from 'react-router-dom';
import ManageLayout from '../components/layouts/ManageLayout';
import AppLayout from '../components/layouts/AppLayout';
import useAuth from '../utils/AuthContext';
import useCheckAuth from '../hooks/useCheckAuth';

export default function RootRouter() {
  const auth = useAuth();
  const checkAuth = useCheckAuth();
  useEffect(() => {
    checkAuth.check();
  }, []);
  return (
    <HashRouter>
      <Switch>
        <Route path={'/manage'} component={ManageLayout} />
        <Route path={'/'} component={AppLayout} />
      </Switch>
    </HashRouter>
  );
}
